import User from './User';

export default class Message {
    public id!: number;
    public content!: string;
    public date!: string;
    public author: User = new User();

    public static fromData(data: any): Message {
        const message = new Message();
        message.id = data.id;
        message.content = data.content;
        message.date = data.date;

        if (data.author) {
            message.author = User.fromData(data.author.data);
        }

        return message;
    }
}
